/**
 * PDP: Child Name line item property (required + maxlength).
 */
(function () {
  function init(root) {
    if (!root || root.dataset.elinProductChildNameInit === '1') return;
    root.dataset.elinProductChildNameInit = '1';

    const formId = root.dataset.productFormId;
    const form = formId ? document.getElementById(formId) : null;
    const input = root.querySelector('[data-elin-child-name-input]');
    const errorEl = root.querySelector('[data-elin-product-child-name-error]');
    const countCurrent = root.querySelector('[data-elin-child-name-count-current]');
    const required = root.dataset.required === 'true';
    const max = parseInt(root.dataset.max || '17', 10) || 17;
    const productForm = form ? form.closest('product-form') : null;

    if (!form || !input) return;

    const updateCount = function () {
      const len = (input.value || '').length;
      if (countCurrent) countCurrent.textContent = String(len);
    };

    input.addEventListener('input', function () {
      if (input.value.length > max) {
        input.value = input.value.slice(0, max);
      }
      updateCount();
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
    });

    updateCount();

    form.addEventListener(
      'submit',
      function (e) {
        const sub = e.submitter;
        if (!sub || sub.getAttribute('name') !== 'add') return;

        const value = (input.value || '').trim();
        if (!required || value) {
          input.value = value;
          return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();

        const msg =
          (window.elinProductChildNameStrings && window.elinProductChildNameStrings.required) ||
          'Please enter the child name before adding to cart.';

        if (errorEl) {
          errorEl.textContent = msg;
          errorEl.hidden = false;
        }

        if (productForm && typeof productForm.handleErrorMessage === 'function') {
          productForm.handleErrorMessage(msg);
        }

        input.focus();
      },
      true
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-elin-product-child-name-root]').forEach(init);
  });
})();
